class CatalogoProductoV1 extends HTMLElement {
  constructor() {
    super();
    this.ids = null;
    this.sizes = [];
    this.sizeSeleccionado = null;
    this.coleccion = null;
    this.productos = null;
    this.sucursal = null;

    this.cantidadDesplazamiento = 500;
    this.maxIndicadores = 6;
    this.indicadorActual = 0;
    this.totalProductos = 0;
  }

  connectedCallback() {
    // REFERENCIAS ELEMENTOS
    this.inicializarReferencias();
    this.inicializarEventos();
    this.cargarDatos();

    this.botonIzquierdaMenu.addEventListener(
      "click",
      this.desplazarIzquierda.bind(this)
    );
    this.botonDerechaMenu.addEventListener(
      "click",
      this.desplazarDerecha.bind(this)
    );
  }

  inicializarReferencias() {
    this.productosHTML = this.querySelectorAll(".producto-item");
    this.tarjetaFinalRedireccion = this.querySelector("#tarjeta-final-redireccion");
    this.coleccion = this.querySelector(
      "#phpi-contenedor-productos-muestra"
    ).dataset.coleccion;
    this.variantes = this.querySelectorAll("#phpi-general-variantes");
    this.sucursal = GestionSucursales.corroborarInfoShopify(
      window.sucursales,
      JSON.parse(localStorage.getItem("sucursal-informacion"))
    );
    this.coleccion = this.querySelector(
      "#phpi-contenedor-productos-muestra"
    ).dataset.coleccion;
    this.botonIzquierdaMenu = this.querySelector("#phpi-btn-izquierda-menu");
    this.botonDerechaMenu = this.querySelector("#phpi-btn-derecha-menu");
    this.menuContainer = this.querySelector(
      "#phpi-contenedor-productos-muestra"
    );

    // Controles Scroll Mobile
    this.contenedorProductos = this.querySelector(
      "#phpi-contenedor-productos-muestra"
    );
    this.btnIzquierdaMobile = this.querySelector(
      "#btn-control-izquierda-mobile"
    );
    this.btnDerechaMobile = this.querySelector("#btn-control-derecha-mobile");
    this.contenedorIndicadores = this.querySelector("#items-scroll-mobile");
  }

  inicializarEventos() {
    // Controles Scroll Mobile
    const productosVisibles = this.querySelectorAll(".producto-item");
    this.totalProductos = productosVisibles.length;
    this.generarIndicadores();
    this.btnIzquierdaMobile?.addEventListener("click", () =>
      this.moverCarruselMobile("izquierda")
    );
    this.btnDerechaMobile?.addEventListener("click", () =>
      this.moverCarruselMobile("derecha")
    );
    this.contenedorProductos?.addEventListener("scroll", () =>
      this.actualizarIndicadorPorScroll()
    );
    this.contenedorItemsVariantes = this.querySelectorAll(
      "#phpi-items-variantes"
    );
    this.tarjetaFinalRedireccion?.addEventListener("click", () => {
      const titulo = this.tarjetaFinalRedireccion.dataset.titulo;
      const coleccion = (
        titulo == "Pizza Clasica" ||
        titulo == "Pizza Premium" ||
        titulo == "Pizza Grande" ||
        titulo == "Pizza Familiar"
      ) ? "Pizzas" : titulo;

      localStorage.setItem('phph-itemMenu', coleccion);
      window.location.href = `/pages/_menu-1?coleccion=${coleccion}`;
    });
  }

  async cargarDatos() {
    // PASO 2: OBTENER INFORMACIÓN DE TAMAÑOS (SOLO PIZZAS)
    this.productos = await GestorProductos.obtenerProductosDeColecciones([
      this.coleccion,
    ]);

    this.productos = this.productos[0].productos;

    // VALIDACIONES YA HECHAS lIQUID
    // - Stock total todas las sucursales -> si no tiene stock no se va mostrar
    // - Estado producto -> Activo o Borrador

    // CASO 1. Validar si hay sucursal seleccionada
    if (this.sucursal) {
      // Seleccionar productos solamente si la sucursal esta activa y tiene stock
      const sucursalEnShopify = window.sucursales.find(
        (s) => s.nombre == this.sucursal.nombre
      );
      this.productos = this.productos.filter((producto) => {
        if (!sucursalEnShopify?.estado) return false;
        const stockDisponible = producto.sucursales.find(
          (s) => s.nombre == this.sucursal.nombre
        ).stock;
        return stockDisponible > 0;
      });
    }


    // PASO 1: Crear mapa de productos una sola vez (fuera del forEach)
    if (!this.productosMap) {
      this.productosMap = new Map();
      this.productos.forEach((producto) => {
        this.productosMap.set(producto.idshopify, producto);
      });
    }

    this.productosHTML.forEach((nodoProducto) => {
      // PASO 1: Optimización - Usar mapa en lugar de find()
      const productoEncontrado = this.productosMap.get(nodoProducto.dataset.id);
      if (!productoEncontrado) {
        console.log("No se encontró el producto en el mapa", nodoProducto.dataset.id);
        // nodoProducto.style.display = "none";
        return;
      }

      // PASO 2: Optimización - Cachear elemento metafield
      if (!productoEncontrado.metafield) {
        console.log("No se encontró el metafield");
        return;
      }

      const metadatos = productoEncontrado.metafield;

      // PASO 3: Optimización - Validación más eficiente
      if (
        metadatos.dia &&
        !GestorProductos.activacionProductoByDate(metadatos.dia).activado
      ) {
        console.log("No se encontró el producto en el mapa");
        // nodoProducto.style.display = "none";
        return;
      }

      // PASO 4: Optimización - Cachear colección una sola vez
      const nombreColeccion = nodoProducto.dataset.coleccion;
      const sonPizzas = nombreColeccion.includes("Pizza");

      // PASO 5: Optimización - Buscar tamaños más eficiente
      if (sonPizzas) {
        this.sizes = metadatos.secciones.find(
          (seccion) => seccion.key === "tamano" || seccion.titulo === "Tamaño"
        );

        // VALIDACIÓN: Verificar que tamanos existe y tiene productos
        if (
          !this.sizes ||
          !this.sizes.productos ||
          !Array.isArray(this.sizes.productos)
        ) {
          console.warn(
            "No se encontró sección de tamaños o productos:",
            this.sizes
          );
          console.log("No se encontró sección de tamaños o productos:", this.sizes);
          // nodoProducto.style.display = "none";
          return;
        }

        // Filtrar productos que tengan sucursales
        this.sizes.productos = this.sizes.productos.filter(
          (producto) => producto.sucursales.length > 0
        );

        if (this.sizes.productos.length === 0) {
          console.log("No hay productos para la sucursal");
          // nodoProducto.style.display = "none";
          return;
        }

        // Si hay sucursal seleccionada, filtrar por esa sucursal
        if (this.sucursal) {
          this.sizes.productos = this.sizes.productos.filter((producto) =>
            producto.sucursales.includes(this.sucursal.id_publico)
          );

          if (this.sizes.productos.length === 0) {
            // nodoProducto.style.display = "none";
            console.log("No hay productos para la sucursal");
            return;
          }
        }
      }

      // PASO 6: Optimización - Cachear elementos DOM
      const contenedorVariantes = nodoProducto.querySelector("#phpi-items-variantes");
      const etiquetaVarianteSeleccionada = nodoProducto.querySelector("#phpi-variante-seleccionado");

      if (contenedorVariantes && this.sizes?.productos?.length) {
        this.sizeSeleccionado = this.sizes.productos[0];

        // PASO 7: Optimización - Actualizar solo si existe el elemento
        if (etiquetaVarianteSeleccionada) {
          etiquetaVarianteSeleccionada.innerHTML = GestorProductos.acortarTitulo(
            this.sizeSeleccionado.titulo
          );
        }

        // PASO 8: Optimización - Template literal más eficiente
        contenedorVariantes.innerHTML = this.sizes.productos
          .map(
            (opcion, indice) => `
        <div 
          data-id="${opcion.id}"
          class="variante-producto-item ${indice === 0 ? "seleccionado" : ""}">
          <p>${GestorProductos.acortarTitulo(opcion.titulo)}</p>
          <p class="color-letras-primary">${opcion.precio} Bs</p>
        </div>
      `
          )
          .join("");
      } else if (sonPizzas) {
        console.log("No hay variantes para la pizza");
        return; // Si es pizza pero no tiene variantes, salir
      }

      // PASO 9: Optimización - Cachear botón de variantes
      const botonVerVariantes = nodoProducto.querySelector("#phpi-view-variantes");
      if (botonVerVariantes && contenedorVariantes) {
        botonVerVariantes.addEventListener("click", () => {
          this.mostrarYOcultarVariantes(nodoProducto, contenedorVariantes);
        });
      }

      // PASO 10: Optimización - Buscar botón una sola vez
      const botonPersonalizar = nodoProducto.querySelector("#btn-personalizar");
      const botonAgregar = nodoProducto.querySelector("#btn-agregar");
      const botonAccion = botonPersonalizar || botonAgregar;

      if (!botonAccion) {
        console.warn(
          "No se encontró botón para producto",
          nodoProducto.dataset.id
        );
        return;
      }

      // PASO 11: Activar navegacion a personalizar el producto
      botonAccion.classList.toggle("desactivado");
      const etiquetaTituloProducto = nodoProducto.querySelector("#item-titulo");
      const imagenProducto = nodoProducto.querySelector("#item-imagen");
      etiquetaTituloProducto.addEventListener("click", () => {
        window.location.href = `${productoEncontrado.url}${this.sizeSeleccionado != null ? `?size=${this.sizeSeleccionado.id}` : ""}`;
      });
      imagenProducto.addEventListener("click", () => {
        window.location.href = `${productoEncontrado.url}${this.sizeSeleccionado != null ? `?size=${this.sizeSeleccionado.id}` : ""}`;
      });
      botonAccion.addEventListener("click", () => {
        window.location.href = `${productoEncontrado.url}${this.sizeSeleccionado != null ? `?size=${this.sizeSeleccionado.id}` : ""}`;
      });

      // PASO 12 : Habilitar la seleccion de variantes para las Pizzas
      if (sonPizzas) {
        const nodosVariante = contenedorVariantes.querySelectorAll(".variante-producto-item");
        nodosVariante.forEach((nodo) => {
          nodo.addEventListener("click", () => {
            this.procesoVarianteSeleccionada(nodoProducto, nodo);
            this.mostrarYOcultarVariantes(nodoProducto, contenedorVariantes);
          });
        });
      }

    });
  }

  mostrarYOcultarVariantes(productoHTML, elementoBase) {
    elementoBase.style.display =
      elementoBase.style.display == "flex" ? "none" : "flex";

    // Obtener todos los elementos cada vez
    const todosLosElementos = this.querySelectorAll("#phpi-items-variantes");
    todosLosElementos.forEach((elemento) => {
      if (elemento !== elementoBase) {
        elemento.style.display = "none";
      }
    });

    // Extra: Cerrar al hacer click fuera
    if (elementoBase.style.display === "flex") {
      const cerrarAlClickExterno = (evento) => {
        if (!productoHTML.contains(evento.target)) {
          elementoBase.style.display = "none";
          document.removeEventListener("click", cerrarAlClickExterno);
        }
      };

      setTimeout(
        () => document.addEventListener("click", cerrarAlClickExterno),
        100
      );
    }
  }

  procesoVarianteSeleccionada(productoHTML, elementoVarianteHTML) {
    // PASO 1: Extraer el título de la variante seleccionada
    const textoTituloVariante = elementoVarianteHTML.querySelector("p:nth-of-type(1)").textContent;

    // PASO 2: Buscar la variante correspondiente en los datos
    const varianteEncontrada = this.sizes.productos.find(producto =>
      producto.titulo.includes(textoTituloVariante)
    );
    if (!varianteEncontrada) return;

    // PASO 3: Si ya está seleccionada la misma, no hacer nada
    if (this.sizeSeleccionado &&
      this.sizeSeleccionado.id == varianteEncontrada.id &&
      this.sizeSeleccionado.titulo == varianteEncontrada.titulo) {
      return;
    }

    // PASO 4: Actualizar selección visual (remover de todos y aplicar al clicado)
    const variantes = productoHTML.querySelectorAll(".variante-producto-item");
    variantes.forEach(v => v.classList.remove("seleccionado"));
    elementoVarianteHTML.classList.add("seleccionado");

    // PASO 5: Guardar la nueva variante seleccionada
    this.sizeSeleccionado = varianteEncontrada;

    // PASO 6: Cachear elementos del DOM
    const etiquetaHTLMVarianteSeleccionada = productoHTML.querySelector("#phpi-variante-seleccionado");
    const descuentoHTML = productoHTML.querySelector(".producto-item-descuento");
    const contenedorPrecios = productoHTML.querySelector(".producto-item-precios");
    const precioHTML = contenedorPrecios?.children?.[0] || null;
    const precioComparacionHTML = contenedorPrecios?.children?.[1] || null;

    // PASO 7: Actualizar descuento
    if (descuentoHTML) {
      descuentoHTML.style.display = varianteEncontrada.precio_comparacion > 0 ? "flex" : "none";
      descuentoHTML.querySelector("p").innerHTML = GestorProductos.calcularDescuento(
        varianteEncontrada.precio,
        varianteEncontrada.precio_comparacion
      );
    }

    // PASO 8: Actualizar precios
    if (precioHTML) {
      precioHTML.innerHTML = varianteEncontrada.precio + " Bs";
    }
    if (precioComparacionHTML) {
      precioComparacionHTML.style.display = varianteEncontrada.precio_comparacion > 0 ? "flex" : "none";
      precioComparacionHTML.innerHTML = varianteEncontrada.precio_comparacion + " Bs";
    }

    // PASO 9: Actualizar etiqueta de variante seleccionada
    if (etiquetaHTLMVarianteSeleccionada) {
      etiquetaHTLMVarianteSeleccionada.innerHTML = GestorProductos.acortarTitulo(varianteEncontrada.titulo);
    }
  }

  desplazarIzquierda() {
    // Verifica que el contenedor existe
    if (!this.menuContainer) {
      console.error("Error: this.menuContainer es undefined");
      return;
    }

    // Desplaza el contenedor
    this.menuContainer.scrollBy({
      left: -this.cantidadDesplazamiento,
      behavior: "smooth",
    });

    // Verifica los botones después del desplazamiento
    setTimeout(() => this.verificarBotones(), 300);
  }

  desplazarDerecha() {
    // Verifica que el contenedor existe
    if (!this.menuContainer) {
      console.error("Error: this.menuContainer es undefined");
      return;
    }

    // Desplaza el contenedor
    this.menuContainer.scrollBy({
      left: this.cantidadDesplazamiento,
      behavior: "smooth",
    });

    // Verifica los botones después del desplazamiento
    setTimeout(() => this.verificarBotones(), 300);
  }

  verificarBotones() {
    // Verificar si el contenedor existe
    if (!this.menuContainer) {
      console.error("Error: this.menuContainer es undefined");
      return;
    }

    // Comprobar inicio
    if (this.menuContainer.scrollLeft <= 0) {
      this.botonIzquierdaMenu.style.opacity = "0.5";
      this.botonIzquierdaMenu.style.pointerEvents = "none";
    } else {
      this.botonIzquierdaMenu.style.opacity = "1";
      this.botonIzquierdaMenu.style.pointerEvents = "auto";
    }

    // Comprobar final
    if (
      this.menuContainer.scrollLeft + this.menuContainer.clientWidth >=
      this.menuContainer.scrollWidth - 10
    ) {
      this.botonDerechaMenu.style.opacity = "0.5";
      this.botonDerechaMenu.style.pointerEvents = "none";
    } else {
      this.botonDerechaMenu.style.opacity = "1";
      this.botonDerechaMenu.style.pointerEvents = "auto";
    }
  }

  generarIndicadores() {
    if (!this.contenedorIndicadores) return;

    this.contenedorIndicadores.innerHTML = "";
    const cantidadIndicadores = Math.min(
      this.totalProductos,
      this.maxIndicadores
    );

    for (let i = 0; i < cantidadIndicadores; i++) {
      const boton = document.createElement("button");
      if (i == 0) boton.classList.add("activo");
      boton.addEventListener("click", () => this.irAIndicador(i));
      this.contenedorIndicadores.appendChild(boton);
    }
  }

  moverCarruselMobile(direccion) {
    if (!this.contenedorProductos) return;

    const anchoScroll = this.contenedorProductos.clientWidth;

    if (direccion == "derecha") {
      this.contenedorProductos.scrollBy({
        left: anchoScroll * 0.7,
        behavior: "smooth",
      });
    } else {
      this.contenedorProductos.scrollBy({
        left: -anchoScroll * 0.7,
        behavior: "smooth",
      });
    }
  }

  actualizarIndicadorPorScroll() {
    if (!this.contenedorProductos) return;

    const scrollLeft = this.contenedorProductos.scrollLeft;
    const anchoContenedor = this.contenedorProductos.clientWidth;
    const anchoTotal = this.contenedorProductos.scrollWidth;

    const progreso = scrollLeft / (anchoTotal - anchoContenedor);
    const cantidadIndicadores = Math.min(
      this.totalProductos,
      this.maxIndicadores
    );
    const nuevoIndicador = Math.round(progreso * (cantidadIndicadores - 1));

    if (nuevoIndicador !== this.indicadorActual) {
      this.indicadorActual = nuevoIndicador;
      this.actualizarIndicadorActivo();
    }
  }

  actualizarIndicadorActivo() {
    const indicadores = this.contenedorIndicadores?.querySelectorAll("button");
    if (!indicadores) return;

    indicadores.forEach((indicador, index) => {
      if (index == this.indicadorActual) {
        indicador.classList.add("activo");
      } else {
        indicador.classList.remove("activo");
      }
    });
  }

  irAIndicador(indice) {
    if (!this.contenedorProductos) return;

    const anchoTotal = this.contenedorProductos.scrollWidth;
    const anchoContenedor = this.contenedorProductos.clientWidth;
    const cantidadIndicadores = Math.min(
      this.totalProductos,
      this.maxIndicadores
    );

    const porcentaje = indice / (cantidadIndicadores - 1);
    const scrollDestino = porcentaje * (anchoTotal - anchoContenedor);

    this.contenedorProductos.scrollTo({
      left: scrollDestino,
      behavior: "smooth",
    });

    this.indicadorActual = indice;
    this.actualizarIndicadorActivo();
  }
}

customElements.define("catalogo-producto-v1", CatalogoProductoV1);

